function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import times from 'lodash/times';
import styles from './SidebarPersonsLoader.pcss';
var _React_PureComponent;
class SidebarPersonsLoader extends (_React_PureComponent = React.PureComponent) {
    renderPerson(idx) {
        return /*#__PURE__*/ _jsx("li", {
            className: `${styles.item} fadingLoader`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto pr-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.item__avatar
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.item__textPlaceholder
                        })
                    })
                ]
            })
        }, idx);
    }
    render() {
        const { itemsNumber } = this.props;
        return /*#__PURE__*/ _jsx("ul", {
            className: styles.items,
            children: times(itemsNumber, (idx)=>this.renderPerson(idx))
        });
    }
}
_define_property(SidebarPersonsLoader, "propTypes", {
    itemsNumber: PropTypes.number
});
_define_property(SidebarPersonsLoader, "defaultProps", {
    itemsNumber: 3
});
export default withStyles(styles)(SidebarPersonsLoader);
